<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="pageInfo.picStr" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="pageInfo.picStr" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>
    </div>

    <div class="row" :class="{'hidden-xs hidden-sm':isShowWeb}">
      <div class="dynamic-center">
        <!-- <div class="center-center-font">地球的气候变化不容乐观。但令人庆幸的是，世界各国所开发的新能源决方案已经在逐步改善我们赖以生存的环境。低碳技术的创新、推广和规模化应用是帮助全球逐渐减少、并最终摆脱对化石能源依赖的主要途径之一。尤其是在一些较大的市场，如美国、中国、印度和欧洲，这种技术创新性的突破可以给社会带来巨大的进步。同时，采用新的工作、居住和旅行方式也能给世界经济注入新的能量。</div>
        <div class="center-center-font">中小企业一直是低碳创新技术研发和推广的重要载体，却面临着市场推广不畅、融资难等诸多挑战、有时，也许技术本身并不是问题，只是尚存的众多阻碍和支持上的不足，影响了这些技术在创新体系中的发展。</div>
        <div class="center-center-font">气候创行者项目(Climate Solve)2008年由WWFI瑞典办公室发起，并于2011年正式落地中国目前在全球五个区域和国家开展工作。该项目旨在为具有变革性温室气体减排潜力的低碳创新技术创造有利的发展条件，推动创新技术的广泛应用，助力低碳转型，从而为全球应对气候变化做出重要贡献。WF希望通过这个平台，来提高各界人士对这些关键创新技术的认识，并且将它们作为切实有效的气候解决方案的价值传播出去</div>
        <div class="center-center-font">气候创行者项目每年在中国举办一届低碳创新技术评选，通过与各地高新区、产业园区、投融资机构、研究机构等开展合作，甄选出以低碳创新为典型特征的中小企业并授予其“低碳创行者称号。这些企业致力于发展拥有巨人温室气体减排潜力的变革性低碳技术，并制定了坚实的商业计划，将会有步骤地推广其创新技术，是全球应对气候变化在技术创新领域的先锋力量。</div>
        <div class="center-center-font">项目旨在汇聚和展示不同国家的优质低碳创新技术和利益相关方，打造国际交流平台，共同助力改善低碳创新技术的推广，融资和发展环境。</div>
        <div class="center-center-font">根据获奖企业的实际情况，WF会为其制定宣传推广计划，入选企业将获得以下支持</div>
        <div class="center-center-font">望造行业先锋企业形象：项目为获奖技术拍摄宣传片，在气候创行者全球创新门户网站展示；邀请媒体对获奖技术进行报道：邀请或资助获奖技术参加国内外交流、宜传、论坛、展览等，展示技术并分享企业经验。</div>
        <div class="center-center-font">加速技术市场化推广：国际化奖项提升获奖技术的市场认可度，增加商业机会；提升企业在环境要求更高的国际市场的竞争力，增加贸易机会；获奖技术可与W企业减排项目或低碳城市示范项目对接。</div>
        <div class="center-center-font">获取更多融资机会：获奖技术将获得更多潜在投资者的关注和融资机会；评审委员会成员来自具有投资和业务兴趣的投融资机构，评选过程本身即是向投资者展示技术和企业的过程。</div>
        <div class="center-center-font">参与国际交流和合作：及时获得国内外同领域尖端低碳技术的信息；获得全球气候创行者平台上的国际交流、市场开拓、技术转移机会；优先参与WW℉全球气侯创新伙伴关系、南南合作、中非可再生能源合作等相关国际合作项目。</div>
        <div class="center-center-font">无论您是一个渴望为城市基础设施寻求新办法的规划者、一位关注清洁技术的投资者，还是一位想要提高口常操作能效的企业领导者，都欢迎您加入我们。让我们共同创建一个振奋人心的低碳未来。</div>
        <div class="center-center-font">诚挚的邀请您加入企业气候行动共同体如有更多疑问，请咨询：</div>
        <div class="center-center-font">芦丽莎  lshlu@wwfchina.org  </div>
        <div class="center-center-font">WWF能源转型项目经理（气候创行者项目）</div>
        <div class="center-center-font">更多关于气候创行者项目的信息</div>
        <div class="center-center-font"> 请访问气候创行者官方网站</div> -->
        <div class="center-center-font" v-html="pageInfo.content"></div>
      </div>
    </div>

    <div class="row hidden-md hidden-lg" v-if="isShowWeb">
      <div class="phone-dynamic-center">
        <!-- <div class="phone-center-font">地球的气候变化不容乐观。但令人庆幸的是，世界各国所开发的新能源决方案已经在逐步改善我们赖以生存的环境。低碳技术的创新、推广和规模化应用是帮助全球逐渐减少、并最终摆脱对化石能源依赖的主要途径之一。尤其是在一些较大的市场，如美国、中国、印度和欧洲，这种技术创新性的突破可以给社会带来巨大的进步。同时，采用新的工作、居住和旅行方式也能给世界经济注入新的能量。</div>
        <div class="phone-center-font">中小企业一直是低碳创新技术研发和推广的重要载体，却面临着市场推广不畅、融资难等诸多挑战、有时，也许技术本身并不是问题，只是尚存的众多阻碍和支持上的不足，影响了这些技术在创新体系中的发展。</div>
        <div class="phone-center-font">气候创行者项目(Climate Solve)2008年由WWFI瑞典办公室发起，并于2011年正式落地中国目前在全球五个区域和国家开展工作。该项目旨在为具有变革性温室气体减排潜力的低碳创新技术创造有利的发展条件，推动创新技术的广泛应用，助力低碳转型，从而为全球应对气候变化做出重要贡献。WF希望通过这个平台，来提高各界人士对这些关键创新技术的认识，并且将它们作为切实有效的气候解决方案的价值传播出去</div>
        <div class="phone-center-font">气候创行者项目每年在中国举办一届低碳创新技术评选，通过与各地高新区、产业园区、投融资机构、研究机构等开展合作，甄选出以低碳创新为典型特征的中小企业并授予其“低碳创行者称号。这些企业致力于发展拥有巨人温室气体减排潜力的变革性低碳技术，并制定了坚实的商业计划，将会有步骤地推广其创新技术，是全球应对气候变化在技术创新领域的先锋力量。</div>
        <div class="phone-center-font">项目旨在汇聚和展示不同国家的优质低碳创新技术和利益相关方，打造国际交流平台，共同助力改善低碳创新技术的推广，融资和发展环境。</div>
        <div class="phone-center-font">根据获奖企业的实际情况，WF会为其制定宣传推广计划，入选企业将获得以下支持</div>
        <div class="phone-center-font">望造行业先锋企业形象：项目为获奖技术拍摄宣传片，在气候创行者全球创新门户网站展示；邀请媒体对获奖技术进行报道：邀请或资助获奖技术参加国内外交流、宜传、论坛、展览等，展示技术并分享企业经验。</div>
        <div class="phone-center-font">加速技术市场化推广：国际化奖项提升获奖技术的市场认可度，增加商业机会；提升企业在环境要求更高的国际市场的竞争力，增加贸易机会；获奖技术可与W企业减排项目或低碳城市示范项目对接。</div>
        <div class="phone-center-font">获取更多融资机会：获奖技术将获得更多潜在投资者的关注和融资机会；评审委员会成员来自具有投资和业务兴趣的投融资机构，评选过程本身即是向投资者展示技术和企业的过程。</div>
        <div class="phone-center-font">参与国际交流和合作：及时获得国内外同领域尖端低碳技术的信息；获得全球气候创行者平台上的国际交流、市场开拓、技术转移机会；优先参与WW℉全球气侯创新伙伴关系、南南合作、中非可再生能源合作等相关国际合作项目。</div>
        <div class="phone-center-font">无论您是一个渴望为城市基础设施寻求新办法的规划者、一位关注清洁技术的投资者，还是一位想要提高口常操作能效的企业领导者，都欢迎您加入我们。让我们共同创建一个振奋人心的低碳未来。</div>
        <div class="phone-center-font">诚挚的邀请您加入企业气候行动共同体如有更多疑问，请咨询：</div>
        <div class="phone-center-font">芦丽莎  lshlu@wwfchina.org  </div>
        <div class="phone-center-font">WWF能源转型项目经理（气候创行者项目）</div>
        <div class="phone-center-font">更多关于气候创行者项目的信息</div>
        <div class="phone-center-font"> 请访问气候创行者官方网站</div> -->
        <div class="phone-center-font" v-html="pageInfo.content"></div>
      </div>
    </div>


    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr } from '@/utils/util';
import config from '@/utils/config';
export default {
  name: 'activity',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      lanType:1,
      page:1,
      per_page:9,
      pageList:[],
      total:0,
      pageUrl:config.urlList,
      isShowWeb:config.urlList.isShowWeb,
      pageInfo:{}
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    queryCampaign(){
      const vm=this
      axios.post(
        `${vm.pageUrl.queryUrl}/api/wwf/videos`,
        {
          page: vm.pageNum,
          per_page: 9,
        },
        
      ).then(res => {
        if(res.data.code==1){
          res.data.data.data.titleEn=res.data.data.data.titleEn?res.data.data.data.titleEn:res.data.data.data.title
          vm.pageList=res.data.data.data
          console.log(res.data.data)
          // vm.current_page=res.data.data.last_page
          // vm.total=res.data.data.total
        }
      })
    },
    choicePage(num){
      const vm=this
      vm.page=num;
      vm.queryCampaign();
    },
    upPage(){
      const vm=this;
      if(vm.page>1){
        vm.page--
        vm.queryCampaign();
      }
    },
    downPage(){
      const vm=this;
      if(vm.page<vm.current_page){
        vm.page++
      }
      vm.queryCampaign();
    },
    moreBtn(){
      const vm=this
      if(vm.total>vm.per_page){
        vm.per_page+=9;
        vm.queryCampaign()
      }
    },
    queryStat(){
      const vm=this
      axios.post(
        `${vm.pageUrl.queryUrl}/api/wwf/stat`,
        {
          source:1,
          url:window.location.href
        },
      ).then(res => {
        
      })
    },
    queryProject(id){
      const vm=this
      let obj = {
        id:id,
        token:localStorage.getItem("Cbhtoken")
      }
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/project`,obj
      ).then(res => {
        if(res.data.code==1){
          res.data.data.picStr=`${config.urlList.imgUrl}${res.data.data.pic}`
          res.data.data.content = res.data.data.content.replace(/(width|height)="\d*"\s*/g, '')
          vm.pageInfo = res.data.data
        }else{
          vm.$toast({
            text: '请登录后再试！',
            type: 'danger',
            duration: 1600
          })
          //vm.$router.push({ path:'/'  })
        }
      })
    },
  },
  created () {
    const vm = this;
  },
  mounted(){
    const vm=this
    vm.queryProject(3)
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
</script>
<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 4.0625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.45rem;
  color: #fff;
  font-family:'wwf';
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
  font-family:'wwf';
}

/**  最新动态  **/
.dynamic-center{
  padding: 0.5rem 2rem;
}
.web-index-neck{
  font-size: 0.375rem;
  color: #000000;
  margin-top: 0.425rem;
  line-height: 1.6;
  position: relative;
}
.web-index-neck::before{
  content: "";
  display: block;
  width: 0.75rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.web-neck-center{
  margin: 0.3125rem 0.5rem 0;
  height: auto;
}
.img-info-list{
  width: 32%;
  height: auto;
  -webkit-box-shadow: #d1d1d1 0px 0px 10px; 
  -moz-box-shadow: #d1d1d1 0px 0px 10px; 
  box-shadow: #d1d1d1 0px 0px 10px;
  margin: 0 4px 0.3rem;
}
.info-list-top{
  width: 100%;
  height: 100%;
  position: relative;
}
.list-top-img{
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
}
.info-list-middle{
  padding: 0.1rem 0.05rem;
  background: #fff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 2px 4px #d1d1d1;
}
.list-middle-tips{
  font-size: 0.1125rem;
  color: #cf6e32;
  font-style: italic;
  text-align: left;
}
.list-middle-title{
  font-size: 0.13rem;
  color: #000;
  /* font-weight: 600; */
  margin-bottom: 0.125rem;
  text-align: left;
  height: 0.35rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-family:'wwf';
}
.list-middle-center{
  font-size: 0.1rem;
  color: #666666;
  line-height: 1.7;
  text-align: left;
}
.info-list-layer{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.list-layer-li{
  margin-bottom: 0.1875rem;
  padding: 6px 10px;
  font-size: 0.0875rem;
  color: #fff;
  background: #cf6e32;
  margin-right: 0.0625rem;
  display: inline-block;
}
.list-layer-li:nth-child(1){
  margin-left: 0.25rem;
}
.neck-indicators{
  position: absolute;
  bottom: 0 !important;
}
.neck-indicators li{
  background: #aaaaaa !important;
}
.glyphicon-chevron-left,.glyphicon-chevron-right{
  margin: 0 !important;
  color: #000;
  text-shadow: none;
  font-size: 18px;
}
.neck-btn-left{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  left: -0.21875rem;
  transform: translateY(-50%);
}
.neck-btn-right{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  right: -0.21875rem;
  transform: translateY(-50%);
}
.dynamic-paging{
  margin-top: 0.325rem;
  padding: 0 0.5rem;
}
.dynamic-paging-btn{
  width: 1.25rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #cf6e32;
  font-weight: 600;
  margin: 0 0.125rem;
}
.dynamic-paging-list{
  width: 0.375rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #cf6e32;
  font-weight: 600;
  margin: 0 0.125rem;
  margin-bottom: 0;
}
.bg1{
  background: #cf6e32;
  color: #fff;
}
.wraps {
  content: "";
  display: block;
  width: 32%;
  height: 1px;
}

/**  web最新动态  **/
.phone-index-neck{
  font-size: 0.72rem;
  font-weight: 500;
  color: #000000;
  margin-top: 0.906rem;
  line-height: 2;
  position: relative;
}
.phone-index-neck::before{
  content: "";
  display: block;
  width: 1.44rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.phone-info-list{
  width: 100%;
  margin-bottom: 1.1rem;
  margin-left: 0;
}
.phone-list-top{
  height: 5.14rem;
  width: 100%;
}
.phone-list-middle{
  padding: 0.2rem 0.4rem;
}
.phone-list-tips{
  font-size: 0.42rem;
  font-weight: 500;
}
.phone-list-title{
  font-size: 0.48rem;
  margin-top: 0.29rem;
  margin-bottom: 0.4rem;
  height: auto;
}
.phone-list-center{
  font-size: 0.42rem;
  margin-top: 0.2rem;
}
.phone-dynamic-center{
  padding: 0.5rem;
}
.phone-legs-btn{
  width: 4rem;
  height: 1.067rem;
  background: #cf6e32;
  font-size: 0.4rem;
  color: #fff;
  margin: 0 auto 0.5rem;
}
.center-center-font{
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-bottom: 0.2rem;
  text-align: left;
}
.phone-center-font{
  font-size: 0.32rem;
  line-height: 1.6;
  margin-bottom: 0.4rem;
  text-align: left;
}
</style>

